import { reactive } from 'vue'

const modals = reactive({})

export function createBvModalPlugin () {
  return {
    install (app) {
      const bvModal = {
        show (id) {
          modals[id] = true
        },
        hide (id) {
          modals[id] = false
        },
        isVisible (id) {
          return !!modals[id]
        }
      }

      app.config.globalProperties.$bvModal = bvModal
      app.provide('bvModals', modals)
    }
  }
}

export { modals as bvModals }
